export default theme => ({
  root: {
    textAlign: 'left',
    paddingTop: theme.sizes.layout.appHeader.height.desktop,
    backgroundColor: theme.palette.white.light,
    marginBottom: '2rem',
    boxShadow: theme.customShadows[1],
  },
});
